import React from 'react'
import { useSelector } from 'react-redux'
import DisconnectedData from './DisconnectedData.container'
import Pagination from '../../components/Tables/Pagination'
import LoadingContent from '../../components/Placeholders/LoadingContent'
import { usePagination } from '../../components/Tables/Pagination.hooks'
import Table from '../../components/Tables/Table'
import TableCell from '../../components/Tables/TableCell'
import TableRow from '../../components/Tables/TableRow'
import { Paper, Box, Grid } from '@material-ui/core'
import Typography from '../../components/Basics/Typography'

const ESTADO_LABEL = {
  matcheada: 'Matcheada',
  solo_dispatch: 'Sólo FMSDiesel',
  solo_orpak: 'Sólo Fluidintel'
}

const formatValue = (value, suffix = '') => {
  if (value === null || value === undefined) {
    return '—'
  }
  return `${value}${suffix}`
}

// 0 = full load, 1 = partial load, null = no ADS data.
const formatCargaParcial = value => {
  if (value === null || value === undefined) {
    return '—'
  }
  return value === 1 ? 'Parcial' : 'Completa'
}

// Background color for the load type: red for partial, green for full.
const cargaParcialColor = value => {
  if (value === null || value === undefined) {
    return ''
  }
  return value === 1
    ? 'rgba(173, 0, 15, 0.15)' // rojo: carga parcial
    : 'rgba(0, 142, 23, 0.18)' // verde: carga completa
}

const FuelLevelOrpak = () => {
  const { fuelSourceComparison } = useSelector(state => state.countdown)
  const { data: comparisonData = [], loading: comparisonLoading = false, error: comparisonError = false } =
    fuelSourceComparison || {}

  // most recent load first (orpak timestamp, falling back to dispatch)
  const sortedComparison = [...comparisonData].sort((a, b) => {
    const aTs = a.tsOrpak || a.tsDispatch || ''
    const bTs = b.tsOrpak || b.tsDispatch || ''
    return bTs.localeCompare(aTs)
  })

  const { page, totalPages, onChangePage, onGetCurrentPage } = usePagination({
    data: sortedComparison,
    initialPage: 1,
    rowsPerPage: 15
  })

  return (
    <>
      {comparisonLoading && <LoadingContent />}
      {!comparisonLoading && comparisonError && <DisconnectedData />}
      {!comparisonLoading && !comparisonError && (
        <>
          <Box>
            <Typography variant="h2" margin="0 0 20px 0">
              Comparación de cargas de combustible entre FMSDiesel y Fluidintel en las últimas 24 horas. Se actualiza
              con cada dato ADS (~5 minutos). Una carga se considera matcheada cuando aparece en ambas fuentes con menos
              de 90 minutos de diferencia.
            </Typography>
            <Paper style={{ overflow: 'auto' }}>
              {sortedComparison.length === 0 ? (
                <>
                  <Table accesibility={{ label: 'Fluidintel' }}>
                    <TableRow head>
                      <TableCell>Equipo</TableCell>
                      <TableCell>Hora FMSDiesel</TableCell>
                      <TableCell>Litros FMSDiesel</TableCell>
                      <TableCell>Hora Fluidintel</TableCell>
                      <TableCell>Litros Fluidintel</TableCell>
                      {/* <TableCell>Δ Litros</TableCell> */}
                      <TableCell>% Diferencia</TableCell>
                      <TableCell>Estado</TableCell>
                      <TableCell>Carga</TableCell>
                    </TableRow>
                  </Table>
                  <Grid container spacing={0} direction="column" alignItems="center">
                    <Typography variant="h1">No hay datos de Fluidintel en las últimas 24 horas</Typography>
                  </Grid>
                </>
              ) : (
                <Table accesibility={{ label: 'Fluidintel' }}>
                  <TableRow head>
                    <TableCell>Equipo</TableCell>
                    <TableCell>Hora FMSDiesel</TableCell>
                    <TableCell>Litros FMSDiesel</TableCell>
                    <TableCell>Hora Fluidintel</TableCell>
                    <TableCell>Litros Fluidintel</TableCell>
                    {/* <TableCell>Δ Litros</TableCell> */}
                    <TableCell>% Diferencia</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Carga</TableCell>
                  </TableRow>

                  {onGetCurrentPage().map((row, index) => {
                    return (
                      <TableRow key={`comparison-${index}`}>
                        <TableCell align="center" minWidth="90px">
                          {row.equipo}
                        </TableCell>
                        <TableCell align="center" minWidth="150px">
                          {formatValue(row.tsDispatch)}
                        </TableCell>
                        <TableCell align="center" minWidth="140px">
                          {formatValue(row.litrosDispatch)}
                        </TableCell>
                        <TableCell align="center" minWidth="150px">
                          {formatValue(row.tsOrpak)}
                        </TableCell>
                        <TableCell align="center" minWidth="140px">
                          {formatValue(row.litrosOrpak)}
                        </TableCell>
                        {/* <TableCell align="center" minWidth="150px">{formatValue(row.diffLitros)}</TableCell> */}
                        <TableCell align="center" minWidth="120px">
                          {formatValue(row.pctDiff, '%')}
                        </TableCell>
                        <TableCell align="center" minWidth="140px">
                          {ESTADO_LABEL[row.estado] || row.estado}
                        </TableCell>
                        <TableCell align="center" minWidth="110px" color={cargaParcialColor(row.cargaParcial)}>
                          {formatCargaParcial(row.cargaParcial)}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </Table>
              )}
              <Pagination alignment="right" count={totalPages} page={page} onChange={onChangePage} />
            </Paper>
          </Box>
        </>
      )}
    </>
  )
}

export default FuelLevelOrpak
